<template>
    <v-card class="mb-4" color="surface-variant" variant="outlined">
        <v-card-title class="text-subtitle-2 py-1 d-flex justify-space-between align-center">
            <span>Target Status Coverage: Primary: {{ primaryTargetName }} | over Effective DPS Time (top) and Global
                Raid Time (bottom)</span>
        </v-card-title>
        <v-card-text class="py-2">
            <div class="d-flex flex-wrap gap-2">
                <div v-for="status in displayedStats" :key="status.id" class="d-flex flex-column align-center mr-3 mb-2"
                    style="width: 50px; cursor: help"
                    :title="`${status.name} (${status.id})\nEff Uptime: ${formatDuration(status.effectiveUptime)}\nAll Uptime: ${formatDuration(status.uptime)}\nEff%: ${Math.round(status.uptimeRatio * 100)}%\nAll%: ${Math.round(status.overallRatio * 100)}%`">
                    <img width="24" height="24" :src='getStatusIconUrl(status.id)' class="rounded"
                        style="object-fit: cover; display: block;" loading="eager" decoding="async"
                        onerror="this.style.display='none'; this.nextElementSibling.style.display='block'" />
                    <v-icon icon="mdi-help-circle-outline" size="24" style="display: none"></v-icon>
                    <div class="d-flex flex-column align-center" style="line-height: 1.1">
                        <span class="text-caption font-weight-bold" style="font-size: 0.75rem !important;">{{
                            Math.round(status.uptimeRatio * 100) }}%</span>
                        <span class="text-caption text-grey" style="font-size: 0.65rem !important;">{{
                            Math.round(status.overallRatio * 100) }}%</span>
                    </div>
                </div>
                <v-btn v-if="stats.length > displayedStats.length" variant="text" size="small" density="compact"
                    @click="showAllStatuses">
                    +{{ stats.length - displayedStats.length }} more
                </v-btn>
            </div>
        </v-card-text>
    </v-card>
</template>

<script lang="ts">
import { defineComponent, computed, ref } from 'vue';

export default defineComponent({
    name: 'TargetStatusCoverage',
    props: {
        stats: {
            type: Array as () => any[],
            required: true
        },
        primaryTargetName: {
            type: String,
            required: true
        },

        formatDuration: {
            type: Function,
            required: true
        },
        getStatusIconUrl: {
            type: Function,
            required: true
        }
    },



    setup(props) {
        const statusDisplayLimit = ref(50);
        const displayedStats = computed(() => {
            return props.stats.slice(0, statusDisplayLimit.value);
        });
        const showAllStatuses = () => { statusDisplayLimit.value = 9999; };

        return {

            displayedStats,
            showAllStatuses
        };
    }
});
</script>
